var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.features_by_layers && _vm.layers.length>0)?_c('div',_vm._l((_vm.layers),function(lay){return _c('div',{key:lay},[(_vm.features_by_layers[lay] && _vm.features_by_layers[lay].length>0)?_c('identity-layer',{attrs:{"layer_id":lay,"features":_vm.features_by_layers[lay]}}):_vm._e()],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }